import { Component } from 'react';

export class MobileErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div dir="rtl" className="min-h-screen bg-slate-100 flex flex-col items-center justify-center p-6 text-center max-w-md mx-auto" data-testid="m-error-screen">
        <div className="w-14 h-14 rounded-2xl bg-[#0F172A] flex items-center justify-center mb-4"><span className="text-[#D4AF37] font-black text-2xl">A</span></div>
        <p className="text-base font-bold text-slate-900">حدث خطأ غير متوقع</p>
        <p className="text-xs text-slate-500 mt-1 mb-4">Something went wrong</p>
        <button onClick={() => { this.setState({ error: null }); window.location.href = '/m'; }} className="h-11 px-6 rounded-xl bg-[#D4AF37] text-[#0F172A] text-sm font-bold" data-testid="m-error-reload">إعادة تحميل التطبيق</button>
      </div>
    );
  }
}
